document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll("video.ske-br-10");
  const contents = document.querySelectorAll(".video-item__content");

  
  const loadAndPlayVideo = (video) => {
    if (!video.src) {
      video.src = video.dataset.src;
      video.addEventListener("canplaythrough", () => {
        video.play();
      });
    }
  };

  // Observer for videos
  const videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          loadAndPlayVideo(video);
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.5 }
  );

  // Observer for content
  const contentObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const content = entry.target;
        if (entry.isIntersecting) {
          content.classList.add("visible");
        }
      });
    },
    { threshold: 0.1 }
  );

  // Observe videos and content
  videos.forEach((video) => videoObserver.observe(video));
  contents.forEach((content) => contentObserver.observe(content));
});


class PopupBase extends HTMLElement {
  constructor() {
    super();
    this.customClass = this.dataset.customClass;
    this.modal = null;
  }

  initPopup(content, text, customClass) {
    const _this = this;
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        const video = this.modalBox.querySelector("video");
        if (!video) return;
        video.play();
        if (this.modal.classList.contains('shopable-video')) {
          video.muted = false
        }
      },
      onClose: function () {},
      beforeClose: function () {
        _this.onCloseEvent();
        return true;
      },
    });
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent;
      let popup_header = document.createElement("div");
      popup_header.classList.add("tingle-modal-box__header");
      popup_header.innerHTML = content;
      let parentElement = popup_content.parentNode;
      parentElement.insertBefore(popup_header, popup_content);
    };
    if (text) {
      this.modal.setHeader(text);
    }

    this.modal.setContent(content);
    this.modal.open();
  }

  onClose() {
    this.modal.close();
  }
  onCloseEvent() {}
}

class ShopableVideo extends PopupBase {
  constructor() {
    super();
    this.popupDiv = this.querySelector(".video-popup-container");
    this.init();
  }
  init() {
    this.addEventListener("click", this.onClick.bind(this));
  }
  onClick() {
    if (this.popupDiv) {
      const html = this.popupDiv;
      if (!html) return;
      html.classList.remove("t4s-d-none");
      this.initPopup(html);
    }
  }
}
customElements.define("shopable-video", ShopableVideo);